type Props = {
  value: string | null | undefined;
  className?: string;
};

const HTML_RE = /<[a-z][\s\S]*>/i;

/**
 * Rend une valeur de texte enrichi. Le HTML a déjà été assaini côté serveur
 * (services/sanitize.ts) avant d'être stocké, d'où le dangerouslySetInnerHTML.
 * Les anciennes bios en texte brut sont rendues avec les sauts de ligne préservés.
 */
export function RichText({ value, className }: Props) {
  if (!value) return null;

  if (HTML_RE.test(value)) {
    return (
      <div
        className={className}
        dangerouslySetInnerHTML={{ __html: value }}
      />
    );
  }

  return (
    <p className={className} style={{ whiteSpace: "pre-wrap" }}>
      {value}
    </p>
  );
}

/** Retire les balises pour un aperçu court (cartes d'admin, etc.). */
export function stripHtml(value: string | null | undefined): string {
  if (!value) return "";
  return value
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/\s+/g, " ")
    .trim();
}
